export default function () {
  return {
    name_tc: null,
    name_en: null,
    position: null,
    contact_email: null,
    contact_tel: null,
    contact_fax: null,
    other_contact: null,
    remarks: null,
  }
}